'use client';

import { Container, Button } from '@mui/material';
import React from 'react';
import { Box } from '@mui/system';
import styles from './styles';

const SkipToMainContent = () => {
  const focusFirstFocusableInsideMain = () => {
    const main = document.getElementById('main');
    if (!main) return;

    // Focusable selectors
    const selector = `
    a[href], button, input, textarea, select,
    [tabindex]:not([tabindex="-1"]), [contenteditable="true"]
  `;

    // Find all focusables inside <main>
    const focusables = Array.from(main.querySelectorAll(selector)).filter(
      el => !el.disabled && el.offsetParent !== null
    );

    if (focusables.length > 0) {
      focusables[0].focus();
    }
  };

  return (
    <Container sx={{ justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
      <Box
        // Wrapper isn't focusable, so shift+tab won't stop here
        tabIndex={-1}
        sx={{
          position: 'relative',

          // Reveal container when the button inside is focused
          '& .reveal': { display: 'none' },
          '&:focus-within .reveal': { display: 'flex' },
        }}
      >
        {/* MAIN BUTTON → only focusable element here */}
        <Button
          variant='buttonLarge'
          disableRipple
          onClick={() => {
            // Ensure this runs only in browser
            if (typeof document === 'undefined') return;

            const main = document.getElementById('main');

            if (main) {
              // Move focus to <main>
              main.focus({ preventScroll: true });

              // Scroll smoothly into view
              main.scrollIntoView({ behavior: 'smooth', block: 'start' });

              // Now shift focus into first focusable child
              setTimeout(() => {
                focusFirstFocusableInsideMain();
              }, 50); // tiny delay ensures scroll completes
            }
          }}
          sx={styles.solidctastyle}
        >
          Skip to main content
        </Button>
      </Box>
    </Container>
  );
};

export default SkipToMainContent;
